import { getRequest } from '@rideiq/api/utils/provider';
import { ApiResponse } from '@rideiq/api/utils/responseTransform';

export async function getDeactivationReasons(signal?: AbortSignal): Promise<ApiResponse<{ reasons }>> {
  return getRequest('passengers/deactivation_reasons', signal);
}
